<div class="properties-grid-surface">
  @if (useTable) {
    <table style="table-layout: fixed;" class="w-full">
      <colgroup>
        <col span="1" [style.width]="labelColWidth">
        <col span="1">
      </colgroup>
      <tbody>
        @for (prop of _props; track prop) {
          <tr>
            <td [ngClass]="{'label': true, '': prop.category != ''}">
              <div class="text-xs text-400 vertical-align-top text-left">{{prop.category}}</div>
              <div title="{{prop.description}}">{{prop.label}}</div>
            </td>
            @if(prop.tdClass?.includes('pre')) {
              @if(prop.tdClass?.includes('json')) {
                <td class="value {{prop.tdClass}}">
                  <pre>{{getObject(prop.key) | json}}</pre>
                </td>
              } @else {
                <td class="value {{prop.tdClass}}">
                    <pre [innerHTML]="getFormattedValue(prop.key)"></pre>
                </td>
              }
            } @else {
              <td class="value {{prop.tdClass}}" [innerHTML]="getFormattedValue(prop.key)"></td>
            }
          </tr>
        }
      </tbody>
    </table>
  }

  @if (!useTable) {
    <div>
      @for (prop of _props; track prop) {
        <div>
          <div class="label">{{prop.label}}</div>
          <div class="value text-wrap" style="overflow-wrap: break-word;" [innerHTML]="getFormattedValue(prop.key)"></div>
        </div>
      }
    </div>
  }
</div>
